export const EXTERNAL_DATA_RESETED = 'EXTERNAL_DATA_RESETED';
export const EXTERNAL_DATA_REQUESTED = 'EXTERNAL_DATA_REQUESTED';
export const EXTERNAL_DATA_FAILURE = 'EXTERNAL_DATA_FAILURE';

export const FETCH_FAQ_SUCCESS = 'FETCH_FAQ_SUCCESS';
export const FETCH_HOSPITALS_SUCCESS = 'FETCH_HOSPITALS_SUCCESS';
export const FETCH_ADVICES_SUCCESS = 'FETCH_ADVICES_SUCCESS';

export const CLEAR_ERROR = 'CLEAR_ERROR';
